import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const location = useLocation(); // Pobieramy aktualną ścieżkę

    // 1. Sprawdzamy, czy użytkownik jest zalogowany
    const isAuthenticated = !!localStorage.getItem('token');
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // 2. Jeśli jest zalogowany, sprawdzamy, czy jego profil jest kompletny
    const prefsRaw = localStorage.getItem('user_preferences');
    const preferences = prefsRaw ? JSON.parse(prefsRaw) : null;

    // --- ZMIENIONE ---
    // Sprawdzamy profil na podstawie nowej flagi `is_profile_complete`.
    // Dajemy `false` jako domyślną wartość, jeśli `preferences` lub flaga nie istnieją.
    const isProfileComplete = preferences?.is_profile_complete || false;

    // 3. Logika przekierowań (pozostaje bez zmian, bo zależy od flagi `isProfileComplete`)
    
    // Jeśli profil JEST NIEKOMPLETNY, a użytkownik NIE JEST na stronie uzupełniania,
    // to przekieruj go tam.
    if (!isProfileComplete && location.pathname !== '/complete-profile') {
        return <Navigate to="/complete-profile" replace />;
    }

    // Jeśli profil JEST KOMPLETNY, a użytkownik próbuje wejść na stronę
    // uzupełniania, przekieruj go do aplikacji (dla lepszego UX).
    // UWAGA: Trzeba tu obsłużyć wyjątek dla ścieżki, na którą wchodzimy *po* uzupełnieniu profilu.
    // Na razie zostawiam, jak było.
    if (isProfileComplete && location.pathname === '/complete-profile') {
        return <Navigate to="/app" replace />;
    }

    // 4. Jeśli wszystkie warunki są spełnione, wyświetl chronioną zawartość
    return children;
};

export default ProtectedRoute;